export const iconFontAwesomeSportsFitnessBowlingBall = (
	<i className="fa-solid fa-bowling-ball"></i>
);
